<template>
	<span :class="caratClasses">
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			width="24px" height="24px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
				<path class="st0" d="M16.9,9.5L12,14.5L7.1,9.5"/>
			</svg>
	</span>
</template>
<script>
export default {
	name: 'IconCarat', 
	props: ['active', 'success', 'error'], 
	computed: {
		caratClasses(){
			return (
				'tb-carat' + 
				(this.active ? ' tb-active' : '') + 
				(this.success ? ' tb-success' : '') + 
				(this.error ? ' tb-error' : '') 
			);
		}
	}
}
</script>
